import {
  LANGUAGE,
  SET_LANGUAGE,
  GET_DICTIONARY,
  GET_LANGUAGES,
  RESULT,
} from "../actions/language.action";
import { Language } from "../store/base/language";
import { API_SUCCESS } from "../actions/api.action";

const initState: any = {
  caruentLanguage: { id: "ar", dir: "rtl" },
} as Language;

function languageReducer(language: Language = initState, action: any) {
  switch (action.type) {
    // Context
    case `${GET_DICTIONARY} ${API_SUCCESS}`:
      return { ...language, dictionary: action.payload } as Language;
      break;

    case SET_LANGUAGE:
      // localStorage.setItem("lang",action.payload);
      var getlang = language.languages.find(id => id.id.match(action.payload));
      language.caruentLanguage = {
        id: getlang?.id || "ar",
        dir: getlang?.dir || "rtl",
      };
      return { ...language } as Language;
      break;

    case `${GET_LANGUAGES} ${API_SUCCESS}`:
      // console.log(action)
      // console.log(`${GET_LANGUAGES} ${API_SUCCESS}`);
      return { ...language, languages: action.payload } as Language;
      break;

    default:
      return { ...language };
  }
}

export default languageReducer;
